import { useState, useEffect } from "react";
import {
  ThreeDotsVertical
} from "react-bootstrap-icons";
import { SubmitHandler, useForm } from "react-hook-form";
import { useNavigate, useParams } from "react-router-dom";
import FormButton from "../../Components/Buttons/FormButton";
import FormToggle from "../../Components/FormTag/FormToggle";
import InputFiled from "../../Components/FormTag/InputFiled";
import PageHeader from "../../Layout/PageHeader";

import ShipToCodeAddEdit from "./ShipToCode/ShipToCodeAddEdit";
import FormSelect from "../../Components/FormTag/FormSelect";
import {
  deleteCustomerShipto,
  getCustomerDetails,
  getcustomerShiptoList,
  submitCustomerForm,
  updateCustomer,
} from "./service/customer.service";
import { ApiResponse, SelcetOption } from "../../model/common/apiResponse";
import { lookUpService } from "../../Services/common/lookup.service";
import Loader from "../../Components/GlobalLoader/Loader";
import toast, { Toaster } from "react-hot-toast";
import { formatPhoneNumber } from "../../Utility/Utility";
import {
  customerDefaultvalues,
  CustomerProps,
  CustomerShipToListProps,
} from "./model/customer.model";
import Table, { Column } from "../../Components/Tables/Table";
import useClientStore, { Client } from "../../store/client/useClientStore";
import { PHONE_USA } from "../../Shared/Helper/Constant";
import { USA_PHONE_PATTERN_ERR_MSG } from "../../Shared/Helper/ValidationMessage";
import CommonConfirmationModal from "../../Components/Modals/CommonConfirmationModal";

export default function CustomerAddEdit() {
  const { id } = useParams();
  const [errMsg, setErrMsg] = useState("");
  const [isShowErr, setShowErr] = useState(false);
  const [hideErrMsgTimeout, setHideErrMsgTimeout] =
    useState<NodeJS.Timeout | null>(null);
  const pageName = "Customer";
  const navigation = useNavigate();
  const [shipToCodeList, setShipToCodeList] = useState<
    CustomerShipToListProps[]
  >([]);
  const [countryList, setCountryList] = useState<SelcetOption[]>([]);
  const [loading, setLoading] = useState(true);
  const [submitting, setSubmitting] = useState(false);
  const [counter, setCounter] = useState<number>(1);
  const [shiptoCodeId, setShiptoCodeId] = useState<string>("");
  const [customerDetails, setCustomerDetails] = useState<CustomerProps>();
  const [updatedShiptodata, setUpdatedShiptodata] = useState([]);
  const {getSelectedClient}= useClientStore();
  const [customerCode, setCustomerCode] = useState<string>("");
  const [clientData, setClientData] = useState<Client | null>(null);

  const [confirmModalData, setConfirmModalData] = useState({
    customer_id: 0,
    showconfModal: false,
    message: "",
  });

  const {
    handleSubmit,
    register,
    reset,
    control,
    setValue,
    formState: { errors },
  } = useForm<CustomerProps>({
    defaultValues: customerDefaultvalues,
  });

  let payload: {
    columns: { data: string; as?: string }[];
    limit: number;
    search?: string;
    page?: number;
    perPage?: number;
    conditions?: any;
  } = {
    columns: [
      {
        data: "customer_ship_to.id",
      },
      {
        data: "customer.id as customer_id",
      },
      {
        data: "customer_ship_to.code",
      },
      {
        data: "customer_ship_to.name",
      },
      {
        data: "customer_ship_to.address_line_1",
      },
      {
        data: "customer_ship_to.address_line_2",
      },
      {
        data: "customer_ship_to.address_line_3",
      },
      {
        data: "customer_ship_to.contact_phone",
      },
      {
        data: "customer_ship_to.city",
      },
      {
        data: "customer_ship_to.state_province",
      },
      {
        data: "customer_ship_to.postal_code",
      },
      {
        data: "customer_ship_to.state_province",
      },
      {
        data: "customer_ship_to.country_code",
      },
    ],
    limit: -1,
  };
  useEffect(() => {
    const subscription = getSelectedClient().subscribe((client) => {
      setClientData(client);
    });

    return () => subscription.unsubscribe();
  }, [getSelectedClient]);
  useEffect(() => {
    fetchData().then(()=>{
    if (id) {
      setLoading(true);
      payload.conditions= [["customer.id", "=", id]];
      getCustomerDetails(id).then(async(data) => {
        data.data.country = data.data.country.code;
        setCustomerDetails(data.data)
       setCustomerCode(data.data.code)
        reset(data.data);
        await getcustomerShiptoList(payload).then((data:any) => {
             setShipToCodeList(data.data.results);
        })
      }).finally(() => {
        setLoading(false);
      })
    }else{
      setLoading(false);
    }
     });
  }, [id, reset, updatedShiptodata]);
  const fetchData = async () => {
    try {
      const countryData = await lookUpService.countryLookup();
      const countryList: SelcetOption[] = countryData.data?.data?.map(
        (obj: any) => ({
          label: obj.name,
          value: obj.code,
        })
      );
      setCountryList(countryList);
    } catch (error) {
      setLoading(false);
    }
  };
  const getClientData = async() => {
    if (clientData && Object.keys(clientData).length>0 && clientData.code!=='all') {
     return clientData;
    } else {
      toast.error("Client code is required!", { duration: 2000 });
      setSubmitting(false);
    }
  };
  const saveData: SubmitHandler<CustomerProps> = async (data) => {
    await getClientData();
    if (!clientData?.id || !clientData?.code || clientData.code==='all') {
      setSubmitting(false);
      return;
    }
    if (submitting) return;
      setShowErr(false);
      setSubmitting(true);
      let formattedCustomerData = {
        ...data,
        client: {
          code: clientData.code,
        }
       
      };
      if(data.country){
        formattedCustomerData.country={
          code: data.country,
        };
      }else{
        formattedCustomerData.country={};
      }
      let response:ApiResponse<any>;
      if (id) {
         response = await updateCustomer(id, formattedCustomerData);
      } else {
        response = await submitCustomerForm(formattedCustomerData);
      }
      if (response.status == 201 || response.status == 200 ) {
        const operationType = id? 'updated':'created';
        toast.success("Customer "+operationType+" successfully!", { duration: 2000 });
        navigation("/account/client/customer/grid-view");
      } else if (response.status == 400) {
        if (response.error.detail.code) {
          toast.error(response.error.detail.code, { duration: 2000 });
        }
        setSubmitting(false);
      } else {
        toast.error("An error occurred while submitting Customer.", {
          duration: 2000,
        });
        setSubmitting(false);
      }
  };

  const handelCancelBtn = () => {
    navigation("/account/client/customer/grid-view");
  };
  const onUpdateShiptoData = (data: any) => {
    setCounter(0);
    setUpdatedShiptodata(data);
  };
  const shiptocolumns: Column[] = [
    {
      name: "Ship to Code",
      selector: (row: CustomerShipToListProps) => row.code,
    },
    {
      name: "Name",
      selector: (row: CustomerShipToListProps) => row.name,
    },
    {
      name: "Address 1",
      selector: (row: CustomerShipToListProps) => row.address_line_1,
    },
    {
      name: "Address 2",
      selector: (row: CustomerShipToListProps) => row.address_line_2,
    },
    {
      name: "Country",
      selector: (row: CustomerShipToListProps) => row.country,
    },
    {
      name: "State",
      selector: (row: CustomerShipToListProps) => row.state_province,
    },
    {
      name: "City",
      selector: (row: CustomerShipToListProps) => row.city,
    },
    {
      name: "Zip/Postal Code",
      selector: (row: CustomerShipToListProps) => row.postal_code,
    },
    {
      name: <></>,
      selector: (row: any) => (
        <>
          <span
            className="cursor-pointer dropdown-toggle action-menu border-none"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            <ThreeDotsVertical />
          </span>
          <ul className="dropdown-menu action-items px-0 py-1">
            <li
              className="cursor-pointer ms-3 mb-1"
              onClick={() => {
                setShiptoCodeId(row?.id?.toString());
                setCounter(counter + 1);
              }}
            >
              Edit
            </li>
            <li
              className="cursor-pointer ms-3 mb-1"
              onClick={() => handleDeleteCustomer(row)}
            >
              Delete
            </li>
          </ul>
        </>
      ),
    },
  ];
  const handleconfClose = () => {
    setConfirmModalData({
      customer_id: 0,
      showconfModal: false,
      message: ``,
    });
  };
  const onModalSubmit = (isAccept: boolean) => {
    if (confirmModalData.customer_id !== 0 && isAccept) {
      deleteCustomerShipto(confirmModalData.customer_id).then(
        (response: ApiResponse<any>) => {
          if (response.status == 200) {
            toast.success("Customer deleted successfully");
            setUpdatedShiptodata(response.data);
          } else {
            toast.error("Failed to delete customer");
          }
        }
      );
    }
    handleconfClose();
  };

  const handleDeleteCustomer = (data: any) => {
    setConfirmModalData({
      customer_id: data.id,
      showconfModal: true,
      message: `Are you sure you want to delete ship to code '${data.name}'?`,
    });
  };

  return !loading ? (
    <>
      <Toaster />
      <PageHeader
        addUrl="/account/client/customer/add"
        listUrl="/account/client/customer/list-view"
        gridUrl="/account/client/customer/grid-view"
        name={pageName}
        viewType={true}
      />
      <div className="clearfix"></div>
      <h5 className="text-start mt-1 mb-3">
        {id ? `Edit Customer (${customerCode})` : "Create Customer"}
      </h5>

      <div className="my-2 bg-white rounded p-3">
        {isShowErr && (
          <div
            className="alert alert-danger text-center position-fixed alert-on-top"
            role="alert"
          >
            {errMsg}
          </div>
        )}
        <div className="text-end pe-4">
          {/* <span className="badge rounded-pill sph-text-bg-light-grey cursor-pointer mx-2">
            <ChevronUp />
          </span>
          <span className="badge rounded-pill sph-text-bg-light-grey cursor-pointer mx-2">
            <TrashFill />
          </span> */}
        </div>

        <div className="d-flex px-2 gap-3">
          <div className="col-4 px-2">
            <label className="fw-medium">Customer Code *</label>
            <div className="mt-1">
              <InputFiled
                type="text"
                name="code"
                tabIndex={1}
                autoFocus={true}
                register={register}
                className="form-control"
                required={true}
                errors={errors?.code}
                placeholder="Enter Customer Code"
              />
            </div>
          </div>
          <div className="col-4 px-2">
            <label className="fw-medium">Customer Name *</label>
            <div className="mt-1">
              <InputFiled
                type="text"
                name="name"
                tabIndex={2}
                register={register}
                className="form-control"
                errors={errors?.name}
                required={true}
                placeholder="Enter Customer Name"
              />
            </div>
          </div>
          <div className="col-3 d-flex px-2 justify-content-center">
            <div className="ms-4">
              <label className="fw-medium">Active</label>
            </div>
            <div className="form-check form-switch sidebar-toggler">
              <div className="mx-2">
                <FormToggle
                  tabIndex={12}
                  defaultChecked={true}
                  register={register}
                  name="is_active"
                />
              </div>
            </div>
          </div>
        </div>

        <div className="d-flex px-2 mt-3 gap-3">
          <div className="col-4 px-2">
            <label className="fw-medium">Address 1</label>
            <div className="mt-1">
              <InputFiled
                type="text"
                name="address_line_1"
                tabIndex={4}
                register={register}
                className="form-control"
                errors={errors?.address_line_1}
                placeholder="Enter Address 1"
              />
            </div>
          </div>
          <div className="col-4 px-2">
            <label className="fw-medium">Address 2</label>
            <div className="mt-1">
              <InputFiled
                type="text"
                name="address_line_2"
                tabIndex={5}
                register={register}
                className="form-control"
                errors={errors?.address_line_2}
                placeholder="Enter Address 2"
              />
            </div>
          </div>
        </div>

        <div className="d-flex px-2 mt-3 gap-3">
          <div className="col-4 px-2">
            <label className="fw-medium">Address 3</label>
            <div className="mt-1">
              <InputFiled
                type="text"
                name="address_line_3"
                tabIndex={5}
                register={register}
                className="form-control"
                errors={errors?.address_line_3}
                placeholder="Enter Address 3"
              />
            </div>
          </div>
          <div className="col-4 px-2">
            <label className="fw-medium">Phone Number</label>
            <div className="mt-1">
              <InputFiled
                type="text"
                name="contact_phone"
                tabIndex={6}
                register={register}
                className="form-control"
                errors={errors?.contact_phone}
                pattern={{
                  type: PHONE_USA,
                  message: USA_PHONE_PATTERN_ERR_MSG,
                }}
                placeholder="000-000-0000"
                onChange={async (e: any) => {
                  const formattedNumber = formatPhoneNumber(e.target.value);
                  setValue("contact_phone", formattedNumber);
                }}
              />
            </div>
          </div>
        </div>

        <div className="d-flex px-2 mt-3 gap-3">
          <div className="col-4 px-2">
            <label className="fw-medium">Country</label>
            <div className="mt-1">
              <FormSelect
                name="country"
                tabIndex={7}
                control={control}
                optionList={countryList}
                className="form-control p-0"
                placeholder="Select"
                errors={errors?.country}
                isSearchable={true}
              />
            </div>
          </div>
          <div className="col-4 px-2">
            <label className="fw-medium">State</label>
            <div className="mt-1">
              <InputFiled
                type="text"
                name="state_province"
                tabIndex={8}
                register={register}
                className="form-control"
                errors={errors?.state_province}
                placeholder="Enter State"
              />
            </div>
          </div>
        </div>

        <div className="d-flex px-2 mt-3 gap-3">
          <div className="col-4 px-2">
            <label className="fw-medium">City</label>
            <div className="mt-1">
              <InputFiled
                type="text"
                name="city"
                tabIndex={9}
                register={register}
                className="form-control"
                errors={errors?.city}
                placeholder="Enter City"
              />
            </div>
          </div>
          <div className="col-4 px-2">
            <label className="fw-medium">Zip/Postal Code</label>
            <div className="mt-1">
              <InputFiled
                type="text"
                name="postal_code"
                tabIndex={10}
                register={register}
                className="form-control"
                maxLength={6}
                errors={errors?.postal_code}
                placeholder="Enter Zip/Postal Code"
              />
            </div>
          </div>
        </div>
      </div>
      <div className="my-2 bg-white rounded py-3">
        <div className="d-flex flex-row-reverse">
          <FormButton
            tabIndex={25}
            className="sph-btn me-4"
            handleClick={handleSubmit(saveData)}
          >
            {id ? "Update" : "Submit"}
          </FormButton>
          <FormButton
            tabIndex={26}
            className="sph-btn sph-shift me-4"
            handleClick={handelCancelBtn}
          >
            Cancel
          </FormButton>
        </div>
      </div>

      {id || shiptoCodeId ? (
        <>
          <div className="mt-1">
            <div className="d-flex justify-content-between align-item-center mb-4">
              <div>
                <h6 className="fw-bold">Ship to Code</h6>
              </div>
              <span tabIndex={11}>
                <ShipToCodeAddEdit
                  customerDetails={customerDetails}
                  countryList={countryList}
                  counter={counter}
                  shiptoCodeId={shiptoCodeId}
                  setShiptoCodeId={setShiptoCodeId}
                  onUpdateShiptoData={onUpdateShiptoData}
                />
              </span>
            </div>
            {shipToCodeList?.length != 0 && (
              <div className="my-2 bg-white rounded py-1 px-4 customer-table-scroll">
                <Table
                  columns={shiptocolumns}
                  data={shipToCodeList ?? []}
                  CheckboxStatus={false}
                  isStripped={true}
                  customClassName="transferDetailsTable"
                />
              </div>
            )}
            <CommonConfirmationModal
              customClassName="header-border"
              show={confirmModalData.showconfModal}
              confirmBtnText="YES"
              cancelBtnText="NO"
              content={<> {confirmModalData.message} </>}
              onModalSubmit={onModalSubmit}
            />
          </div>
        </>
      ) : (
        <></>
      )}

      {/* </div> */}
    </>
  ) : (
    <Loader />
  );
}
